import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    },
    load: "languageOnly",
    ns: ["translation_v1.0.12"],
    backend: {
      loadPath: `${process.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
      addPath: `${process.env.BASE_URL}locales/{{lng}}/{{ns}}.json`
    },
    supportedLngs: ["en", "es"],
    detection: { order: ["navigator"] },
    nonExplicitSupportedLngs: true
  });

export default i18n;
